export const getPrefectureName = (prefKey) => {
  if (areaToPrefTable.find((item) => item.key === prefKey)) {
    return areaToPrefTable.find((item) => item.key === prefKey).name
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === prefKey)
    if (pref) {
      return pref.name
    }
  }
  return null
}

export const setWindRank = (windSpd) => {
  if (windSpd < 1) {
    return 0
  } else if (windSpd < 5) {
    return 1
  } else if (windSpd < 8) {
    return 2
  } else if (windSpd < 12) {
    return 3
  } else if (windSpd < 18) {
    return 4
  } else if (windSpd < 100) {
    return 5
  } else {
    return null
  }
}

export const getJpAreaName = (areaKey) => {
  const areaName = areaKey ? areaToPrefTable.find(({ key }) => key === areaKey)?.name : '全国'
  return areaName
}
